import { TESTIMONIAL_ROTATE_MS, TESTIMONIALS } from '@/constants/testimonials';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { useEffect, useState } from 'react';

/**
 * One customer quote at a time, moving to the next on the sign-up page's
 * beat. Holds while hovered; holds the first quote for reduced motion.
 */
export function RotatingQuote() {
  const [active, setActive] = useState(0);
  const [paused, setPaused] = useState(false);
  const reduceMotion = useReducedMotion();

  useEffect(() => {
    if (paused || reduceMotion) return;
    const timer = window.setInterval(
      () => setActive((i) => (i + 1) % TESTIMONIALS.length),
      TESTIMONIAL_ROTATE_MS
    );
    return () => window.clearInterval(timer);
  }, [paused, reduceMotion]);

  const t = TESTIMONIALS[active];

  return (
    <div
      className='relative min-h-[104px] w-full max-w-[480px]'
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
    >
      <AnimatePresence mode='wait' initial={false}>
        <motion.figure
          key={t.name}
          initial={{ opacity: 0, y: 4 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -4 }}
          transition={{ duration: 0.35, ease: 'easeOut' }}
          className='flex items-start gap-3 text-left'
        >
          <img
            src={t.avatar}
            alt=''
            className='h-9 w-9 shrink-0 rounded-full object-cover'
          />
          <div>
            <blockquote className='text-[13px] leading-5 text-foreground'>
              &ldquo;{t.quote}&rdquo;
            </blockquote>
            <figcaption className='mt-1 text-xs text-muted-foreground'>
              {t.name}, {t.role} at {t.company}
            </figcaption>
          </div>
        </motion.figure>
      </AnimatePresence>
      <div className='mt-3 flex justify-center gap-1.5' aria-hidden='true'>
        {TESTIMONIALS.map((item, i) => (
          <span
            key={item.name}
            className={`h-1 rounded-full transition-all duration-300 ${
              i === active ? 'w-4 bg-foreground/50' : 'w-1 bg-foreground/15'
            }`}
          />
        ))}
      </div>
    </div>
  );
}
